<template>
  <div class="w-full border-b sm:border-b-2 mb-3.75" :style="{ borderColor: categoryParentData.color }">
    <OLink class="text-white text-lg font-bold flex items-center" pure :href="category.href">
      <div
        v-if="categoryParentData.icons.iconCode"
        class="u-center w-11 h-11 rounded-t-md mx-4"
        :style="{
          backgroundColor: categoryParentData.color,
        }"
      >
        <OIcon :icon="`category/${categoryParentData.icons.iconCode}-white`" class="category-icon" />
      </div>
      <h1
        :style="{
          color: categoryParentData.color,
        }"
      >
        {{ category.name.toLocaleUpperCase(LANG) }}
      </h1>
    </OLink>
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { LANG } from '~/constants/config';
import { OLink, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OLink, OIcon },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  setup({ category }) {
    const categoryParentData = category?.parent ? category?.parent : category;
    return { categoryParentData, LANG };
  },
});
</script>
<style lang="scss">
.category-icon {
  path {
    fill: #fff;
  }
}
</style>
